// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_navbar__JtEs\\+ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(0.75rem);
  border-bottom: 1px solid rgba(128, 128, 128, 0.3); }

.styles_name__3HjQn {
  font-size: 1.75rem;
  font-weight: 300;
  color: #808080e6; }

.styles_navContainer__rJHjK {
  padding: 0.5rem 2rem;
  width: 100%; }

.styles_navContent__jy1\\+T {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%; }

.styles_logoSection__9HGEF {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer; }

.styles_logoIcon__AWhPn {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
  scale: 1.25; }
  .styles_logoIcon__AWhPn img {
    max-width: 100%;
    max-height: 100%; }
  .styles_logoIcon__AWhPn svg {
    max-width: 100%;
    max-height: 100%;
    transform: scale(1.5); }

.styles_logoSvg__uuvqb {
  width: 1rem;
  height: 1rem;
  color: white;
  scale: 1.25; }

.styles_navLinks__D9xsy {
  display: none;
  align-items: center;
  gap: 2rem; }
  @media (min-width: 48rem) {
    .styles_navLinks__D9xsy {
      display: flex; } }

.styles_navLink__c0Ivi {
  color: #808080e6;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  height: 1.75rem;
  position: relative;
  font-weight: 500;
  padding: 0 0.25rem; }
  .styles_navLink__c0Ivi:hover {
    color: #4f46e5; }
  .styles_navLink__c0Ivi:focus-visible {
    color: #4f46e5; }
  .styles_navLink__c0Ivi::after {
    content: attr(data-fullname);
    position: absolute;
    left: 50%;
    top: calc(100% + 0.35rem);
    transform: translateX(-50%);
    background: rgba(17, 24, 39, 0.92);
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 0.375rem;
    font-size: 0.85rem;
    white-space: nowrap;
    line-height: 1;
    opacity: 0;
    pointer-events: none;
    transition: opacity 160ms ease, transform 180ms ease;
    transform-origin: top center;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.12); }
  .styles_navLink__c0Ivi:hover::after, .styles_navLink__c0Ivi:focus-visible::after {
    opacity: 1;
    transform: translateX(-50%) translateY(0.1rem); }

.styles_authButtons__JkhcU {
  display: flex;
  align-items: center;
  gap: 0.75rem; }

.styles_authButton__xEln4 {
  position: relative;
  padding: 0.5rem 1rem;
  border: 2px solid transparent;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1); }
  .styles_authButton__xEln4:hover {
    transform: scale(1.02);
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15); }
  .styles_authButton__xEln4:first-child {
    background: rgba(255, 255, 255, 0.9);
    border-color: #6366f1;
    color: #6366f1; }
    .styles_authButton__xEln4:first-child:hover {
      background: #6366f1;
      color: white; }
  .styles_authButton__xEln4:last-child {
    background: linear-gradient(90deg, #6366f1, #8b5cf6);
    color: white;
    border-color: transparent; }
    .styles_authButton__xEln4:last-child:hover {
      background: linear-gradient(90deg, #4f46e5, #7c3aed); }

button.styles_boothsButton__bLvHs {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.5rem;
  background: linear-gradient(90deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.2));
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 0.75rem;
  color: #6366f1;
  transition: all 0.3s ease;
  padding: 0.5rem 3rem; }
  button.styles_boothsButton__bLvHs:hover {
    background: linear-gradient(90deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));
    transform: scale(1.05); }
    button.styles_boothsButton__bLvHs:hover p {
      color: white; }

.styles_arrowIcon__m6nan {
  width: 1rem;
  height: 1rem;
  color: #6366f1; }

button.styles_mobileMenuButton__kz6iA {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none; }
  @media (min-width: 48rem) {
    button.styles_mobileMenuButton__kz6iA {
      display: none; } }

.styles_mobileMenuIcon__koqLa {
  width: 1.25rem;
  height: 1.25rem;
  color: #808080b8; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/Header/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2CAA2C;EAC3C,8BAA8B;EAC9B,iDCGgB,EAAA;;ADAlB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBCEgB,EAAA;;ADElB;EAGE,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qDAAqD;EACrD,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW,EAAA;EAVb;IAYI,eAAe;IACf,gBAAgB,EAAA;EAbpB;IAgBI,eAAe;IACf,gBAAgB;IAChB,qBAAqB,EAAA;;AAKzB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW,EAAA;;AAWb;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;EAET;IALF;MAMI,aAAa,EAAA,EAEhB;;AAED;EACE,gBCxEgB;EDyEhB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;EARpB;IAUY,cAAc,EAAA;EAV1B;IAWoB,cAAc,EAAA;EAXlC;IAeI,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,2BAA2B;IAC3B,kCAAkC;IAClC,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,oDAAoD;IACpD,4BAA4B;IAC5B,iDAA8C,EAAA;EA/BlD;IAoCI,UAAU;IACV,8CAA8C,EAAA;;AAIlD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD,EAAA;EATnD;IAYI,sBAAsB;IACtB,gDAAgD,EAAA;EAbpD;IAkBI,oCAAoC;IACpC,qBAAqB;IACrB,cAAc,EAAA;IApBlB;MAuBM,mBAAmB;MACnB,YAAY,EAAA;EAxBlB;IA8BI,oDAAoD;IACpD,YAAY;IACZ,yBAAyB,EAAA;IAhC7B;MAmCM,oDAAoD,EAAA;;AAK1D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oFAAoF;EACpF,yCAAyC;EACzC,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,oBAAoB,EAAA;EAVtB;IAaI,oFAAoF;IACpF,sBAAsB,EAAA;IAd1B;MAgBM,YAAY,EAAA;;AAKlB;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY,EAAA;EAEZ;IATF;MAUI,aAAa,EAAA,EAEhB;;AAED;EACE,cAAc;EACd,eAAe;EACf,gBC3MgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  background-color: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(0.75rem);\n  border-bottom: 1px solid rgba($grey18, 0.3);\n}\n\n.name {\n  font-size: 1.75rem;\n  font-weight: 300;\n  color: $grey90;\n}\n\n\n.navContainer {\n//   max-width: 80rem;\n//   margin: 0 auto;\n  padding: 0.5rem 2rem;\n  width: 100%;\n}\n\n.navContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.logoSection {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n.logoIcon {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 1rem;\n  scale: 1.25;\n  img {\n    max-width: 100%;\n    max-height: 100%;\n  }\n  svg {\n    max-width: 100%;\n    max-height: 100%;\n    transform: scale(1.5);\n  }\n\n}\n\n.logoSvg {\n  width: 1rem;\n  height: 1rem;\n  color: white;\n  scale: 1.25;\n\n\n}\n\n// .logoText {\n//   font-size: 1.25rem;\n//   font-weight: 300;\n//   color: $grey90;\n// }\n\n.navLinks {\n  display: none;\n  align-items: center;\n  gap: 2rem;\n  \n  @media (min-width: 48rem) {\n    display: flex;\n  }\n}\n\n.navLink {\n  color: $grey90;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  height: 1.75rem;\n  position: relative;\n  font-weight: 500;\n  padding: 0 0.25rem;\n  \n  &:hover { color: #4f46e5; }\n  &:focus-visible { color: #4f46e5; }\n\n  // Tooltip with full name\n  &::after {\n    content: attr(data-fullname);\n    position: absolute;\n    left: 50%;\n    top: calc(100% + 0.35rem);\n    transform: translateX(-50%);\n    background: rgba(17, 24, 39, 0.92);\n    color: white;\n    padding: 0.25rem 0.5rem;\n    border-radius: 0.375rem;\n    font-size: 0.85rem;\n    white-space: nowrap;\n    line-height: 1;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 160ms ease, transform 180ms ease;\n    transform-origin: top center;\n    box-shadow: 0 0.25rem 0.75rem rgba(0,0,0,0.12);\n  }\n\n  &:hover::after,\n  &:focus-visible::after {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0.1rem);\n  }\n}\n\n.authButtons {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.authButton {\n  position: relative;\n  padding: 0.5rem 1rem;\n  border: 2px solid transparent;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-size: 0.875rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);\n  \n  &:hover {\n    transform: scale(1.02);\n    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15);\n  }\n  \n  // Login button styling (first button)\n  &:first-child {\n    background: rgba(255, 255, 255, 0.9);\n    border-color: #6366f1;\n    color: #6366f1;\n    \n    &:hover {\n      background: #6366f1;\n      color: white;\n    }\n  }\n  \n  // Register button styling (second button)\n  &:last-child {\n    background: linear-gradient(90deg, #6366f1, #8b5cf6);\n    color: white;\n    border-color: transparent;\n    \n    &:hover {\n      background: linear-gradient(90deg, #4f46e5, #7c3aed);\n    }\n  }\n}\n\nbutton.boothsButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1.5rem;\n  background: linear-gradient(90deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.2));\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  border-radius: 0.75rem;\n  color: #6366f1;\n  transition: all 0.3s ease;\n  padding: 0.5rem 3rem;\n  \n  &:hover {\n    background: linear-gradient(90deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));\n    transform: scale(1.05);\n    p {\n      color: white;\n    }\n  }\n}\n\n.arrowIcon {\n  width: 1rem;\n  height: 1rem;\n  color: #6366f1;\n}\n\nbutton.mobileMenuButton {\n  width: 2rem;\n  height: 2rem;\n  display: flex; ///hdden for now\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  \n  @media (min-width: 48rem) {\n    display: none;\n  }\n}\n\n.mobileMenuIcon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: $grey72;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `styles_navbar__JtEs+`,
	"name": `styles_name__3HjQn`,
	"navContainer": `styles_navContainer__rJHjK`,
	"navContent": `styles_navContent__jy1+T`,
	"logoSection": `styles_logoSection__9HGEF`,
	"logoIcon": `styles_logoIcon__AWhPn`,
	"logoSvg": `styles_logoSvg__uuvqb`,
	"navLinks": `styles_navLinks__D9xsy`,
	"navLink": `styles_navLink__c0Ivi`,
	"authButtons": `styles_authButtons__JkhcU`,
	"authButton": `styles_authButton__xEln4`,
	"boothsButton": `styles_boothsButton__bLvHs`,
	"arrowIcon": `styles_arrowIcon__m6nan`,
	"mobileMenuButton": `styles_mobileMenuButton__kz6iA`,
	"mobileMenuIcon": `styles_mobileMenuIcon__koqLa`
};
export default ___CSS_LOADER_EXPORT___;
